<template>
  <section-container>
    <header-page
      title_header="Criando uma Nova Loja"
      sub_header="Uma nova loja para compartilha na sua rede social"
    />
    <content-e class="px-2">
      <div class="bg-white shadow-2l rounded p-2 md:p-6">
        <h2
          class="
            text-md
            font-bold
            mb-4
            pb-4
            border-b border-dashed
            block
            w-full
          "
        >
          Informações da Loja
        </h2>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form
            action=""
            class="flex flex-wrap w-full focus-within:bg-red-200"
            ref="formStore"
            @submit.prevent="handleSubmit(doStoreMyStore)"
          >
            <div class="w-full md:w-1/3 p-2 mt-10">
              <image-preview-e :preview="previewImage"></image-preview-e>
              <ui-switch v-model="display" class="my-5">
                <span class="font-display">Exibir Loja</span>
              </ui-switch>
            </div>
            <div class="w-full md:w-2/3 flex flex-wrap p-2 md:p-6">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'store' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="name"
                  label="Nome da sua loja:"
                  required
                ></input-icon>
              </div>
              <div class="w-full p-2">
                <input-icon-url
                  :icon="{ name: 'link-alt' }"
                  id="slug"
                  :url="`.${$settings.store_url}`"
                  name="slug"
                  type="text"
                  v-model="slug"
                  label="Url de compartilhamento:"
                ></input-icon-url>
              </div>
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'whatsapp', type: 'logo' }"
                  id="contact_whatsapp"
                  name="contacts[whatsapp]"
                  type="text"
                  v-mask="'+55 (##) #####-####'"
                  v-model="contacts.whatsapp"
                  label="N° para contato no Whatsapp com (DDD):"
                  required
                ></input-icon>
              </div>
              <div class="w-full p-2">
                <label for="" class="font-bold text-md mb-2">Descrição:</label>
                <textarea
                  name="description"
                  id="description"
                  cols="10"
                  v-model="description"
                  rows="5"
                  class="
                    focus:shadow-focus
                    focus:border-indigo-400
                    mt-1
                    focus:bg-gray-100
                    appearance-none
                    border
                    rounded
                    w-full
                    py-4
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none
                  "
                ></textarea>
              </div>
            </div>
            <!-- <h2
              class="text-md font-bold mb-4 pb-4 border-b border-dashed block w-full"
            >
              Contatos
            </h2>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'whatsapp', type: 'logo' }"
                  id="contact_whatsapp"
                  name="contacts[whatsapp]"
                  type="text"
                  v-mask="'+55 (##) #####-####'"
                  v-model="contacts.whatsapp"
                  label="N° para contato no Whatsapp com (DDD):"
                  required
                ></input-icon>
              </div>
            </div>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <ValidationProvider rules="email" v-slot="{ errors }">
                  <input-icon
                    :icon="{ name: 'mail-send' }"
                    id="contact_email"
                    name="contacts[email]"
                    type="email"
                    v-model="contacts.email"
                    label="E-mail de contato:"
                  ></input-icon>
                  <span class="text-red-500 block pt-1" v-if="errors.length">
                    <i class="bx bx-error mr-1"></i>
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <input-icon-url
                  :icon="{ name: 'link-alt' }"
                  id="contact_facebook"
                  :url="`facebook.com/`"
                  name="contacts[facebook]"
                  type="text"
                  v-model="contacts.facebook"
                  label="Página no facebook:"
                ></input-icon-url>
              </div>
            </div>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <input-icon-url
                  :icon="{ name: 'link-alt' }"
                  id="contact_instagram"
                  :url="`instagram.com/`"
                  name="contacts[instagram]"
                  type="text"
                  v-model="contacts.instagram"
                  label="Página no Instagram:"
                ></input-icon-url>
              </div>
            </div>

            <h2
              class="text-md font-bold mb-4 pb-4 border-b border-dashed block w-full"
            >
              Endereço
            </h2>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'map' }"
                  id="address_zipcode"
                  name="address[zipcode]"
                  type="text"
                  v-mask="'#####-###'"
                  v-model="zipcode"
                  max="9"
                  label="Cep:"
                ></input-icon>
                <small
                  >Informe o cep do endereço atual para preenchimento
                </small>
              </div>
            </div>
            <div
              v-if="address_card"
              class="w-full rounded border-b-4 border-indigo-500"
            >
              <div class="flex flex-wrap">
                <div
                  class="w-full md:w-12/12 md:mb-0 p-4 md:p-4 border-2 border-b-0 border-gray-200"
                >
                  <h3 class="text-md font-bold">Endereço</h3>
                  <p class="text-lg my-5">
                    Rua: {{ address.street }},
                    <span v-if="address.number" class="font-bold"
                      >N°{{ address.number }}</span
                    >
                    <span v-if="address.complement" class="font-bold">
                      Complemento: {{ address.complement }}</span
                    >
                    <br />
                    Bairro: {{ address.neighborhood }}, Cidade:
                    {{ address.city }} - {{ address.uf }}
                  </p>
                  <ui-switch v-model="display_address" class="my-5">
                    <span class="font-display">Exibir endereço</span>
                  </ui-switch>
                </div>

                <div class="w-full md:w-5/12 md:mb-0 p-4 md:p-4 bg-gray-200">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input-icon
                      :icon="{ name: 'map' }"
                      id="address_number"
                      name="address_number"
                      type="text"
                      v-model="address.number"
                      label="Numero:"
                    ></input-icon>
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div
                  class="w-full md:w-7/12 md:mb-0 p-0 px-4 py-2 md:p-4 bg-gray-200"
                >
                  <input-icon
                    :icon="{ name: 'map' }"
                    id="address_complement"
                    name="address_complement"
                    type="text"
                    v-model="address.complement"
                    label="Complemento:"
                  ></input-icon>
                  <small class="text-gray-600 text-xs">Ex: BLOCO 3 AP 42</small>
                </div>
              </div>
            </div>
            <h2
              class="text-md font-bold my-4 pb-4 border-b border-dashed block w-full"
            >
              Marketing
            </h2>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'analyse' }"
                  id="gtag"
                  name="gtag"
                  type="text"
                  v-model="gtag"
                  label="Google Analitycs:"
                ></input-icon>
                <small
                  >Configure o google Analitycs ou Google Tag(Gtag) para
                  capturar eventos gerados</small
                >
              </div>
            </div>
            <div class="w-full md:w-1/2 flex flex-wrap">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'facebook', type: 'logo' }"
                  id="facebook_pixel"
                  name="facebook_pixel"
                  type="text"
                  v-model="facebook_pixel"
                  label="Facebook Pixel:"
                ></input-icon>
                <small
                  >Configure o pixel do facebook para capturar eventos
                  gerados</small
                >
              </div>
            </div> -->
            <div class="w-full flex flex-wrap border-t border-dashed my-5">
              <div class="w-full p-2 mt-5">
                <button-icon
                  icon="plus"
                  :text="
                    $route.name === 'settings.store'
                      ? 'Atualizar Vitrine'
                      : 'Criar minha Vitrine Online'
                  "
                  class="bg-indigo-600 font-bold"
                />
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
extend('email', email)

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})

extend('email', {
  ...email,
  message: 'Endereço de e-mail não é valido'
})
export default {
  data() {
    return {
      previewImage: require('@/assets/img/photo_upload.png'),
      slug_name: true,
      name: '',
      description: '',
      slug: '',
      display: true,
      display_address: true,
      gtag: '',
      facebook_pixel: '',
      contacts: {
        whatsapp: '',
        facebook: '',
        instagram: '',
        email: ''
      },
      address_card: false,
      zipcode: null,
      address: {}
    }
  },
  watch: {
    name() {
      if (this.slug_name) {
        this.slug = this.toSlug(this.name)
      }
    },
    zipcode() {
      if (this.zipcode.length === 9) {
        this.doAddress()
      } else {
        this.address_card = false
      }
    }
  },
  methods: {
    toSlug(str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      var to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
    doAddress() {
      this.$store
        .dispatch('util/getAddressByCep', this.zipcode)
        .then(response => {
          const address = response.data
          this.address = {
            zipcode: address.data.cep,
            street: address.data.logradouro,
            complement: address.data.complemento,
            neighborhood: address.data.bairro,
            city: address.data.localidade,
            uf: address.data.uf,
            ddd: address.data.ddd
          }
          this.address_card = !this.address_card
        })
    },
    async getStore() {
      const store = await this.$store.dispatch('store/MY_STORES')
      this.slug_name = false
      this.name = store.data.name
      this.slug = store.data.slug
      this.contacts = store.data.contacts
      this.display = store.data.display
      this.description = store.data.description
      this.previewImage = `${this.$settings.image_url}/store/${store.data.id}/logo.jpg`
    },
    doStoreMyStore() {
      const action =
        this.$route.name === 'settings.store'
          ? 'store/UPDATE_STORE'
          : 'store/CREATE_STORE'
      const formData = new FormData(this.$refs.formStore)
      if (this.$refs.formStore.image_upload.files.length > 0) {
        formData.append('logo', this.$refs.formStore.image_upload.files[0])
      }
      formData.append('display', this.display)
      formData.append('display_address', this.display_address)
      Object.keys(this.contacts).map((key, index) => {
        formData.append(`contacts[${key}]`, this.contacts[key])
      })
      this.$store
        .dispatch(action, formData)
        .then(response => {
          const updated = this.$route.name === 'settings.store'
          this.$toasted.success(
            updated ? 'Atualizado com sucesso' : 'Loja Criada com sucesso!',
            {
              position: 'bottom-center',
              duration: 5000,
              icon: 'check'
            }
          )
          if (!updated) {
            window.fbq('track', 'CompleteRegistration', {
              value: '0.00',
              currency: 'BRL'
            })
          }
          this.$router.push({
            name: updated ? 'settings.index' : 'dashboard'
          })
        })
        .catch(error => {
          if (error.status === 422) {
            const msg = Object.values(error.data.errors)
            msg.forEach((item, i) => {
              this.$toasted.error(item, {
                position: 'top-center',
                duration: 5000,
                icon: 'close'
              })
            })
          }
          if (error.status === 405) {
            this.$toasted.error(error.data.message, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          }
        })
    }
  },
  async beforeMount() {
    if (this.$store.state.store.id && !this.$route.name === 'settings.store') {
      this.$router.push({ name: 'dashboard' })
    }

    if (this.$route.name === 'settings.store') {
      await this.getStore()
    }
  }
}
</script>

<style></style>
